export interface Skills {
  name: string;
  proficiency: number;
}

export const programmingLanguages: Skills[] = [
  {
    name: 'C# and .Net&nbsp;',
    proficiency: 8,
  },
  {
    name: 'ASP.Net',
    proficiency: 6,
  },
  {
    name: 'JavaScript',
    proficiency: 6,
  },
  {
    name: 'TypeScript',
    proficiency: 7,
  },
  {
    name: 'JQuery',
    proficiency: 6,
  },
  {
    name: 'C++',
    proficiency: 3,
  },
];

export const javascriptFrameworks: Skills[] = [
  {
    name: 'React',
    proficiency: 5,
  },
  {
    name: 'Angular',
    proficiency: 3,
  },
  {
    name: 'Bootstrap',
    proficiency: 3,
  },
  {
    name: 'IgniteUI',
    proficiency: 3,
  },
  {
    name: 'MUI',
    proficiency: 3,
  },
  {
    name: 'Angular Material',
    proficiency: 3,
  },
  {
    name: 'Knockout.js',
    proficiency: 7,
  },
  {
    name: 'Next.js',
    proficiency: 3,
  },
];

export const devops: Skills[] = [
  {
    name: 'Azure DevOps',
    proficiency: 6,
  },
  {
    name: 'IIS',
    proficiency: 4,
  },
  {
    name: 'SpecFlow',
    proficiency: 6,
  },
  {
    name: 'Git',
    proficiency: 8,
  },
];
